import { $, jQuery } from 'jquery';
import { EVENT } from "../constant"
import { Emitter } from "../core"
import gsap from "gsap";
import * as dat from "dat.gui";
import SplitType from "split-type";

import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
//import {GUI} from 'three/';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass';
import { DotScreenPass } from 'three/examples/jsm/postprocessing/DotScreenPass';
import { GlitchPass } from 'three/examples/jsm/postprocessing/GlitchPass';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass';
import { RGBShiftShader } from 'three/examples/jsm/shaders/RGBShiftShader';
import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass';
import { BokehPass } from 'three/examples/jsm/postprocessing/BokehPass';
import { ClearPass } from 'three/examples/jsm/postprocessing/ClearPass';
import { SobelOperatorShader } from 'three/examples/jsm/shaders/SobelOperatorShader';
import { SSAARenderPass } from 'three/examples/jsm/postprocessing/SSAARenderPass';
import { SSAOPass } from 'three/examples/jsm/postprocessing/SSAOPass'
//import { BokehShader, BokehDepthShader } from 'three/examples/jsm/shaders/BokehShader2';

import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { DirectionalLight, Group } from 'three';

import { getMouseDegrees, getMousePos } from '../utils/bearFollowMouse'
let instance = null;

export default class Experience {
    constructor() {
        if (instance) {
            return instance
        }
        instance = this;
        this.init();
    }

    init() {
        this.spaghetti();
        //this.setup();
        //this.enableGUI();
        //this.loadResource();
        //this.startAnim();
    }

    setup() {
        console.log('EXP setting up');
        const canvas = document.querySelector('canvas');
        const scene = new THREE.Scene();
        //const devicePixelRatio = window.devicePixelRatio || 1;
        const devicePixelRatio = 1;
        // Sizes
        const sizes = {
            width: window.innerWidth,
            height: window.innerHeight,
        }
        //Camera
        const cameraGroup = new THREE.Group();
        const camera = new THREE.PerspectiveCamera(24, sizes.width / sizes.height)
        camera.position.z = 12;
        cameraGroup.add(camera);
        scene.add(cameraGroup);

        // Renderer
        const renderer = new THREE.WebGLRenderer({
            canvas,
            alpha: true,
            antialias: true,
        })
        renderer.setPixelRatio(devicePixelRatio);
        renderer.shadowMap.enabled = true;
        renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        //renderer.setClearColor(0x0e0e0e, 0.0);
        //renderer.physicallyCorrectLights
        //renderer.outputEncoding = THREE.sRGBEncoding;
        renderer.toneMapping = THREE.CineonToneMapping;

        // Assign
        const objectDistance = 4;
        // Mesh & Materials
        let beehive;
        let mtl_dark, mtl_dark_skin, mtl_stand, mtl_dark_hive, mtl_dark_bee;
        // Load models
        let model, bear, bearGroup, chair, stand;
        let book, chat, color, cup, mac, musicnote_1, musicnote_2, pen, phone;
        let array, array_2;
        let root, head, neck, thighL, thighR, footR, footL;
        let hive, hiveGroup, mixerHive;
        //Lights
        let directLight, directLight2, directLight3, directLight4, directLight5;
        let spotLight, rimLight;
        // Trigger boolean
        let allowFollowMouse = false;

        // Materials
        mtl_dark = new THREE.MeshStandardMaterial({
            color: 0x020202,
            flatShading: true,
            roughness: .85,
            metalness: 1,
            transparent: true,
            opacity: 1,
            emissive: 0x0e0e0e,
            //wireframe: true
        })
        mtl_stand = new THREE.MeshStandardMaterial({
            color: 0x020202,
            flatShading: true,
            roughness: .85,
            metalness: 1,
            transparent: true,
            opacity: 1,
            emissive: 0x0e0e0e,
            //wireframe: true,
        })
        mtl_dark_skin = new THREE.MeshStandardMaterial({
            color: 0x020202,
            flatShading: true,
            roughness: .85,
            metalness: 1,
            transparent: true,
            opacity: 1,
            emissive: 0x0e0e0e,
            skinning: true,
            //wireframe: true,
        })
        mtl_dark_hive = new THREE.MeshStandardMaterial({
            color: 0x020202,
            //flatShading: true,
            roughness: .85,
            metalness: 1,
            transparent: true,
            opacity: 1,
            emissive: 0x0e0e0e,
        })
        mtl_dark_bee = new THREE.MeshStandardMaterial({
            color: 0x020202,
            flatShading: true,
            roughness: .85,
            metalness: 1,
            transparent: true,
            opacity: 1,
            emissive: 0x0e0e0e,
            skinning: true,
        })

        const parameters = {
            lightIntensity: 2,
            sceneBackground: false,
            sobel: false,
            rgbShift: false,
            glitch: false,
            glitchWild: false,
            bokeh: false,
            ssaa: false,
            ssao: false,
            toneMap: false,
        }

        // Post-processing
        const renderTarget = new THREE.WebGLRenderTarget(
            sizes.width,
            sizes.height,
            {
                // Anti-aliasing for WebGL2
                samples: renderer.getPixelRatio() === 1 ? 2 : 0,
            }
        )

        const composer = new EffectComposer(renderer);
        composer.setSize(sizes.width, sizes.height);
        composer.setPixelRatio(devicePixelRatio);

        // const clearPass = new ClearPass(0x0e0e0e, 0);
        // composer.addPass(clearPass)
        const renderPass = new RenderPass(scene, camera);
        composer.addPass(renderPass);
        //renderPass.clear = false

        const dotScreenPass = new DotScreenPass()
        dotScreenPass.enabled = false;
        composer.addPass(dotScreenPass);

        const glitchPass = new GlitchPass()
        glitchPass.goWild = parameters.glitchWild;
        glitchPass.enabled = parameters.glitch;
        composer.addPass(glitchPass);

        const rgbShiftPass = new ShaderPass(RGBShiftShader);
        rgbShiftPass.enabled = parameters.rgbShift;
        rgbShiftPass.uniforms.amount.value = .0025;
        composer.addPass(rgbShiftPass);

        const unrealBloomPass = new UnrealBloomPass();
        unrealBloomPass.threshold = 1;
        unrealBloomPass.strength = 1;
        unrealBloomPass.radius = 1;
        //composer.addPass(unrealBloomPass)

        // Anti-aliasing for WebGL1
        if (renderer.getPixelRatio() === 1 && !renderer.capabilities.isWebGL2) {
            const smaaPass = new SMAAPass();
            composer.addPass(smaaPass);

            console.log('Using SMAA')
        }

        const effectSobel = new ShaderPass(SobelOperatorShader);
        effectSobel.enabled = parameters.sobel;
        effectSobel.uniforms['resolution'].value.x = sizes.width * devicePixelRatio;
        effectSobel.uniforms['resolution'].value.y = sizes.height * devicePixelRatio;
        composer.addPass(effectSobel)

        const bokehPass = new BokehPass(scene, camera, {
            aperture: .0004,
            maxblur: 0.1,
            width: sizes.width,
            height: sizes.height
        });
        bokehPass.uniforms['focus'].value = 12;
        bokehPass.enabled = parameters.bokeh;
        composer.addPass(bokehPass)

        const ssaaRenderPass = new SSAARenderPass(scene, camera);
        ssaaRenderPass.enabled = parameters.ssaa;
        composer.addPass(ssaaRenderPass)

        const ssaoPass = new SSAOPass(scene, camera, sizes.width, sizes.height);
        ssaoPass.kernelRadius = 16;
        ssaoPass.enabled = parameters.ssao;
        composer.addPass(ssaoPass);

        composer.renderTarget = renderTarget;

        // Lightings 
        function addLights() {
            directLight = new THREE.DirectionalLight(0xffffff, parameters.lightIntensity * 4);
            directLight.position.set(3, 1.5, -1);
            directLight.target.position.set(0, 2, 0);
            directLight.castShadow = true;
            scene.add(directLight.target);
            scene.add(directLight);
            directLight.shadow.mapSize.width = 2048;
            directLight.shadow.mapSize.height = 2048;

            directLight2 = new THREE.DirectionalLight(0xffffff, parameters.lightIntensity * 3);
            directLight2.position.set(-3, 1.5, -1);
            directLight2.target.position.set(0, 2, 0);
            directLight2.castShadow = true;
            scene.add(directLight2.target);
            scene.add(directLight2);
            directLight2.shadow.mapSize.width = 2048;
            directLight2.shadow.mapSize.height = 2048;

            directLight3 = new THREE.DirectionalLight(0xffffff, parameters.lightIntensity * 2);
            directLight3.position.set(3, 2, 0);
            directLight3.target.position.set(0, 0, -1);
            directLight3.castShadow = true;
            scene.add(directLight3.target);
            scene.add(directLight3);

            directLight4 = new THREE.DirectionalLight(0xffffff, parameters.lightIntensity * 2);
            directLight4.position.set(-3, 2, 0);
            directLight4.target.position.set(0, 0, -1);
            directLight4.castShadow = true;
            scene.add(directLight4.target);
            scene.add(directLight4);

            directLight5 = new THREE.DirectionalLight(0xffffff, parameters.lightIntensity * 3);
            directLight5.position.set(0, 3, 2);
            directLight5.target.position.set(0, 0, -1);
            directLight5.castShadow = true;
            scene.add(directLight5.target);
            scene.add(directLight5);

            spotLight = new THREE.SpotLight(
                0xffffff,
                0,
                0,
                Math.PI / 4,
                .1,
                parameters.lightIntensity * 1
            );
            spotLight.penumbra = .75
            spotLight.position.set(-2, -3, -3);

            rimLight = new THREE.SpotLight(
                0xffffff,
                2,
                0,
                Math.PI / 4,
                .1,
                parameters.lightIntensity * 1
            );
            rimLight.position.set(0, 0, -3);

            scene.add(spotLight);
            scene.add(rimLight);
            animLight();
        }
        addLights();

        function animLight() {
            const tlLight = gsap.timeline({
                defaults: {
                    ease: "none"
                }
            });
            tlLight.to(spotLight.position, { x: -2.5, y: 0, duration: .6, delay: 1 })
                .to(spotLight, { intensity: parameters.lightIntensity * 1, duration: .6 }, '<0')
                .to(spotLight.position, { x: -2, y: 3, duration: .6 }, '<0.6')
                .to(spotLight.position, { x: 2, y: 3, duration: .8, })
                .to(spotLight.position, { x: 2.5, y: 0, duration: .6, })
                .to(spotLight.position, { x: 2, y: -3, duration: .6, })
                .to(spotLight, { intensity: 0, duration: .6 }, '<0')

            const tlLight2 = gsap.timeline({
                delay: tlLight.duration() / 3 * 2,
                onComplete: () => {
                    document.querySelector('.sc-home-hero').classList.remove('hide')
                    document.querySelector('.header').classList.remove('before-loading')
                    allowFollowMouse = true;
                }
            });
            tlLight2
                .from(directLight, { intensity: 0, duration: 1.2 }, '>.4')
                .from(directLight2, { intensity: 0, duration: 1.2 }, '<0')
                .from([directLight3, directLight4, directLight5], { intensity: 0, duration: 1.2, stagger: 0.1 }, '<0')
                .from(rimLight, { intensity: 0, duration: 1.2 }, '<0')
                .to('.blur-bg', { opacity: .5, duration: .6 }, '<0')
        }
    }

    loadResource() {
        console.log('EXP Start loading resources');
        // draco
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('https://raw.githubusercontent.com/mrdoob/three.js/dev/examples/jsm/libs/draco/');
        dracoLoader.setDecoderConfig({ type: 'js' })
        dracoLoader.preload();

        // gltf
        const gltfLoader = new GLTFLoader();
        gltfLoader.setDRACOLoader(dracoLoader)

        //Load models
        gltfLoader.load('../../img/bp2-4-comp.glb', (glb) => {
            bear = glb.scene
            bearGroup = new THREE.Group();
            bearGroup.add(bear)
            scene.add(bearGroup)
            // Customize models 
            bear.traverse((obj) => {
                if (obj.isMesh) {
                    if (obj.name == 'bear') {
                        model = obj;
                        model.material = mtl_dark_skin;
                        model.castShadow = true
                        model.receiveShadow = true
                    } else {
                        obj.material = mtl_dark
                        obj.receiveShadow = true
                    }
                }
                switch (obj.name) {
                    case "book":
                        book = obj;
                        break;
                    case "chat":
                        chat = obj;
                        break;
                    case "color":
                        color = obj;
                        break;
                    case "cup":
                        cup = obj;
                        break;
                    case "mac":
                        mac = obj;
                        break;
                    case "musicnote_1":
                        musicnote_1 = obj;
                        break;
                    case "musicnote_2":
                        musicnote_2 = obj;
                        break;
                    case "pen":
                        pen = obj;
                        break;
                    case "phone":
                        phone = obj;
                        break;
                    case "chair":
                        chair = obj;
                        chair.castShadow = true;
                        chair.receiveShadow = true;
                        break;
                    case "head":
                        head = obj;
                        break;
                    case "neck":
                        neck = obj;
                        break;
                    case "root":
                        root = obj;
                        break;
                    case "thighL":
                        thighL = obj;
                        break;
                    case "thighR":
                        thighR = obj;
                        break;
                    case "footR":
                        footR = obj;
                        break;
                    case "footL":
                        footL = obj;
                        break;
                    default:
                        break;
                }
            })
            initAnimStuffs();
            setTimeout(() => {
                window.SCROLL.start();
                initBearInteraction();
            }, 5800);
            requestAnimationFrame(tick);
        })
        let standGroup = new THREE.Group()
        gltfLoader.load('../../img/bp-standing.glb', (glb) => {
            Emitter.emit(EVENT.EXPERIENCE_LOADED2);
            stand = glb.scene;
            stand.position.z = 8;
            stand.scale.set(2.2, 2.2, 2.2)
            standGroup.add(stand);
            scene.add(standGroup)
            console.log(stand)
            stand.position.y = -1 * objectDistance;
            stand.traverse((obj) => {
                if (obj.name == 'bear-standing') {
                    obj.material = mtl_stand;
                    obj.castShadow = true;
                    obj.receiveShadow = true;
                }
            })

            initBearStandAnim();
        })
        hiveGroup = new THREE.Group();
        gltfLoader.load('../img/bp2-hive-3.glb', (glb) => {
            hive = glb.scene;
            hive.position.x = -3.2;
            hive.position.z = 12;
            hive.position.y = -1 * objectDistance;
            hive.traverse((obj) => {
                if (obj.isMesh) {
                    if (obj.name == 'hive') {
                        obj.material = mtl_dark_hive;
                    } else {
                        obj.material = mtl_dark_bee;
                    }
                }
            })
            mixerHive = new THREE.AnimationMixer(hive);
            mixerHive.timeScale = 14;
            const clip = glb.animations.find((clip) => clip.name === 'hive-animation');
            let animHive = mixerHive.clipAction(clip);
            console.log(glb.animations)
            animHive.play();
            hiveGroup.add(hive)
            scene.add(hiveGroup)

        })
    }

    enableGUI() {
        //dat GUI
        const gui = new dat.GUI();
        let folder_bear = gui.addFolder('mtl_bear');
        let folder_objects = gui.addFolder('mtl_objects');
        let folder_stand = gui.addFolder('mtl_stand');
        let folder_lights = gui.addFolder('lightings');
        let folder_postPro = gui.addFolder('postprocessing');
        folder_bear.add(mtl_dark_skin, 'roughness', 0, 1, 0.05).name('mtl_roughness')
        folder_bear.add(mtl_dark_skin, 'metalness', 0, 1, 0.05).name('mtl_metalness')
        folder_bear.add(mtl_dark_skin, 'wireframe')
        folder_objects.add(mtl_dark, 'roughness', 0, 1, 0.05).name('mtl_roughness')
        folder_objects.add(mtl_dark, 'metalness', 0, 1, 0.05).name('mtl_metalness')
        folder_objects.add(mtl_dark, 'wireframe')
        folder_stand.add(mtl_stand, 'roughness', 0, 1, 0.05).name('mtl_roughness')
        folder_stand.add(mtl_stand, 'metalness', 0, 1, 0.05).name('mtl_metalness')
        folder_stand.add(mtl_stand, 'wireframe')
        folder_lights.add(parameters, 'lightIntensity', 0.5, 8, 0.5).name('light_intensity').onChange(() => {
            directLight.intensity = parameters.lightIntensity * 4;
            directLight2.intensity = parameters.lightIntensity * 3;
            directLight3.intensity = parameters.lightIntensity * 2;
            directLight4.intensity = parameters.lightIntensity * 2;
            directLight5.intensity = parameters.lightIntensity * 3;
            rimLight.intensity = parameters.lightIntensity * 1;
        })
        folder_postPro.add(parameters, 'sceneBackground').onChange(function () {
            parameters.sceneBackground ? scene.background = new THREE.Color('#0e0e0e') : scene.background = null
        })
        folder_postPro.add(parameters, 'toneMap').onChange(() => {
            if (parameters.toneMap) {
                renderer.toneMapping = THREE.CineonToneMapping
            } else {
                renderer.toneMapping = THREE.NoToneMapping;
            }
        })
        folder_postPro.add(parameters, 'sobel').onChange(() => { effectSobel.enabled = parameters.sobel })
        folder_postPro.add(parameters, 'glitch').onChange(() => { glitchPass.enabled = parameters.glitch })
        folder_postPro.add(parameters, 'glitchWild').onChange(() => { glitchPass.goWild = parameters.glitchWild })
        folder_postPro.add(parameters, 'rgbShift').onChange(() => { rgbShiftPass.enabled = parameters.rgbShift })
        folder_postPro.add(parameters, 'bokeh').onChange(() => { bokehPass.enabled = parameters.bokeh })
        folder_postPro.add(parameters, 'ssaa').onChange(() => { ssaaRenderPass.enabled = parameters.ssaa })
        folder_postPro.add(parameters, 'ssao').onChange(() => { ssaoPass.enabled = parameters.ssao })
    }

    startAnim() {
        console.log('Start intro anim')
        function initBearInteraction() {
            allowFollowMouse = true;
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: '.sc-home-hero',
                    start: 'top top',
                    end: 'bottom top',
                    scrub: 0,
                    onLeave: () => {
                        gsap.set('.experience', { 'filter': 'blur(0px)', overwrite: true });
                        gsap.to('.grad-bg', { autoAlpha: 1, duration: 1, overwrite: true });
                        document.querySelector('.sc-home-about').style.zIndex = '1';
                    },
                    onEnterBack: () => {
                        gsap.to('.grad-bg', { autoAlpha: 0, duration: 1, overwrite: true });
                        document.querySelector('.sc-home-about').style.zIndex = '5';
                    }
                },
                defaults: {
                    ease: 'none'
                },
                onUpdate: function () {
                    if (this.progress() >= 0.33) {
                        allowFollowMouse = false;
                    } else {
                        allowFollowMouse = true;
                    }
                }
            })
            tl.to(bearGroup.rotation, { y: Math.PI, duration: 10 }, '0')
                .to('.sc-home-hero', { yPercent: 33, duration: 10 }, '0')
                .to('.sc-home-hero .home-hero-grad', { yPercent: -100, duration: 20 }, '0')
                .to(bearGroup.position, { z: 10, duration: 20 }, '10')
                .to(mtl_dark_skin, { opacity: 0, duration: 1, }, '>-=1')
                .to(mtl_dark, { opacity: 0, duration: 1, }, '<0')
                .to('.experience', { 'filter': 'blur(14px)', duration: 3 }, '<-=3')
        }
        function initAnimStuffs() {
            let stuffs = bear.children[1].children;
            stuffs.forEach(function (e, i) {
                let timeDelay = i * 0.08 + 3
                gsap.from(e.scale, { x: 0, y: 0, z: 0, duration: 1.2, ease: "Power2.easeOut", delay: timeDelay })
                gsap.from(e.position, { y: 0, z: 0, duration: 1.2, ease: "Power2.easeOut", delay: timeDelay })
                gsap.from(e.rotation, { y: -2, z: -2, duration: 1.2, ease: "Power2.easeOut", delay: timeDelay })
            })
        }
        function initBearFollowMouse(e) {
            let mousecoords = e;
            const moveJointHead = (mouse, joint, degreeLimit) => {
                let degrees = getMouseDegrees(mouse.x, mouse.y, degreeLimit);
                joint.rotation.z = THREE.MathUtils.lerp(
                    joint.rotation.z,
                    ((0.0405 + THREE.Math.degToRad(degrees.x)) * Math.PI) / 10,
                    0.1
                );
                joint.rotation.x =
                    0.14 +
                    THREE.MathUtils.lerp(
                        joint.rotation.x,
                        ((0.2 - THREE.Math.degToRad(degrees.y)) * Math.PI) / 10,
                        0.1
                    );
            };
            const moveJointNeck = (mouse, joint, degreeLimit) => {
                let degrees = getMouseDegrees(mouse.x, mouse.y, degreeLimit);
                joint.rotation.y = THREE.MathUtils.lerp(
                    joint.rotation.y,
                    (THREE.Math.degToRad(degrees.x) * Math.PI) / 10,
                    0.1
                );
                joint.rotation.x =
                    0.05 +
                    THREE.MathUtils.lerp(
                        joint.rotation.x,
                        ((0.8767 - THREE.Math.degToRad(degrees.y)) * Math.PI) / 10,
                        0.1
                    );
            };
            const moveJointBase = (mouse, joint, degreeLimit) => {
                let degrees = getMouseDegrees(mouse.x, mouse.y, degreeLimit);
                joint.rotation.y = THREE.MathUtils.lerp(
                    joint.rotation.y,
                    (THREE.Math.degToRad(degrees.x) * Math.PI) / 10,
                    0.1
                );
                joint.rotation.x = THREE.MathUtils.lerp(
                    joint.rotation.x,
                    (THREE.Math.degToRad(degrees.y) * Math.PI) / 10,
                    0.1
                );
            };
            moveJointHead(mousecoords, head, -60);
            moveJointNeck(mousecoords, neck, 15);
            moveJointBase(mousecoords, bear, 24);
        }
        function anim_hovering(stuff) {
            stuff.position.y += Math.sin(1 * 1000 + clock.elapsedTime) / 1200;
            stuff.rotation.x +=
                (Math.sin(1 * 1000 + clock.elapsedTime) * Math.PI) / 2000;
            stuff.rotation.y +=
                (Math.cos(1 * 1000 + clock.elapsedTime) * Math.PI) / 3000;
            stuff.rotation.z +=
                (Math.sin(1 * 1000 + clock.elapsedTime) * Math.PI) / 4000;
        }
        function anim_hovering_2(stuff) {
            stuff.position.y -= Math.sin(1 * 1000 + clock.elapsedTime) / 1000;
            stuff.rotation.x +=
                (Math.sin(1 * 1000 + clock.elapsedTime) * Math.PI) / 2000;
            stuff.rotation.y +=
                (Math.cos(1 * 1000 + clock.elapsedTime) * Math.PI) / 3000;
            stuff.rotation.z +=
                (Math.sin(1 * 1000 + clock.elapsedTime) * Math.PI) / 4000;
        }
        function initBearStandAnim() {
            const tlStand = gsap.timeline({
                scrollTrigger: {
                    trigger: '.sc-home-proj',
                    start: 'top bottom+=200%',
                    end: 'bottom+=20% bottom',
                    scrub: 0,
                    //markers: true,
                    onEnter: () => {
                        allowFollowMouse = true;
                        gsap.set('.experience', { 'filter': 'blur(0px)' })
                        console.log('enter')
                    },
                    onLeaveback: () => {
                        allowFollowMouse = false;
                        gsap.set('.experience', { 'filter': 'blur(8px)' })
                    }
                },
                default: {
                    ease: 'none'
                }
            })
            setTimeout(() => {
                tlStand
                    //.to(hive.position, { x: -3.1, z: 0, y: -.4 * objectDistance, duration: 10 })
                    .to(hive.position, { x: -3.1, z: 0, y: .2 * objectDistance, duration: 15 }, '0')
                    //.to(stand.position, { y: -.6 * objectDistance, z: -5.6, duration: 10 }, '0')
                    .to(stand.position, { y: -.1 * objectDistance, z: -5.6, duration: 15 }, '0')
                    .to('.experience', { 'filter': 'blur(6px)', duration: 4 }, '5')
                    .from(stand.rotation, { y: Math.PI / 2, duration: 15 }, '0')

                //.to(mtl_stand, { opacity: 0, duration: 2 }, '>-=2')    
            }, 3000);
        }

        renderer.setSize(sizes.width, sizes.height);
        renderer.render(scene, camera);

        // Times
        const clock = new THREE.Clock();
        let previousTime = 0;

        // Mouse 
        let cursor = {};
        cursor.x = 0;
        cursor.y = 0;

        let followCursor = {}
        followCursor.x = 0;
        followCursor.y = 0;

        let raycasterCursor = {};
        raycasterCursor.x = 0;
        raycasterCursor.y = 0;

        const raycaster = new THREE.Raycaster();

        window.addEventListener('mousemove', function (e) {
            cursor.x = (e.clientX / sizes.width) - .5;
            cursor.y = (e.clientY / sizes.height) - .5;
            followCursor.x = getMousePos(e).x;
            followCursor.y = getMousePos(e).y;
            raycasterCursor.x = cursor.x * 2;
            raycasterCursor.y = cursor.y * - 2;
        })

        // Scroll
        let scrollY = window.scrollY;

        window.addEventListener('scroll', () => {
            scrollY = window.scrollY;
        })

        const tick = () => {
            const elapsedTime = clock.getElapsedTime();
            const deltaTime = elapsedTime - previousTime;
            previousTime = elapsedTime;

            // Animate camera
            cameraGroup.position.y = - scrollY / sizes.height * objectDistance;
            standGroup.position.y = - scrollY / sizes.height * objectDistance;
            bearGroup.position.y = - scrollY / sizes.height * objectDistance;
            hiveGroup.position.y = - scrollY / sizes.height * objectDistance;
            // Parallax 
            const parallaxX = cursor.x;
            const parallaxY = cursor.y;

            // Idle Anim stuffs and bone

            if (bear) {
                if (allowFollowMouse) {
                    initBearFollowMouse(followCursor);
                    camera.position.x += (parallaxX - camera.position.x) * .8 * deltaTime;
                    //camera.position.y += (- parallaxY - camera.position.y) * .5 * deltaTime;
                } else {
                    if (bear.rotation.y > 0) {
                        bear.rotation.y += (0 - bear.rotation.y) * .9 * deltaTime;
                    }
                    if (camera.position.x > 0) {
                        camera.position.x += (0 - camera.position.x) * .9 * deltaTime;
                    }
                }
                array = [chat, cup, mac, pen, phone];
                array.map((item) => {
                    anim_hovering(item);
                });
                array_2 = [book, color, musicnote_1, musicnote_2];
                array_2.map((item) => {
                    anim_hovering_2(item);
                });
                chair.position.y -= Math.sin(1 * 1000 + elapsedTime) / 2400;
                root.position.y -= Math.sin(1 * 1000 + elapsedTime) / 1400;
                thighL.position.y -= Math.sin(1 * 1000 + elapsedTime) / 1000;
                thighR.position.y -= Math.sin(1 * 1000 + elapsedTime) / 1000;

                // Raycaster
                raycaster.setFromCamera(raycasterCursor, camera);
                const array_3 = [...array, ...array_2];
                const intersects = raycaster.intersectObjects(array_3);

                for (const intersect of intersects) {
                    //console.log(intersect.object)
                    //intersect.object.material.color.set('#00ff00')
                    //intersect.object.scale.x = Math.sin(1 * 1000 + elapsedTime);
                }
                // for (const obj_stuff of array_3) {
                //     if (!intersects.find(intersect => intersect.object === obj_stuff)) {
                //         obj_stuff.material.color.set('#030303');
                //     }
                // }
            }

            if (mixerHive) {
                mixerHive.update(clock.getDelta() * mixerHive.timeScale);
            }

            //Without post-pro
            //renderer.render(scene, camera);

            // With post-pro
            composer.render();

            requestAnimationFrame(tick)
        }
        window.addEventListener('resize', onWindowResize);
        function onWindowResize() {
            sizes.width = window.innerWidth;
            sizes.height = window.innerHeight;
            //Update camera
            camera.aspect = sizes.width / sizes.height;
            camera.updateProjectionMatrix();
            //Update renderer
            renderer.setSize(sizes.width, sizes.height);
            renderer.setPixelRatio(devicePixelRatio);
            //Update composer
            composer.setSize(sizes.width, sizes.height);
            composer.setPixelRatio(devicePixelRatio)

        }
    }

    spaghetti() {
        const canvas = document.querySelector('canvas');
        const scene = new THREE.Scene();
        //const devicePixelRatio = window.devicePixelRatio || 1;
        const devicePixelRatio = 1;
        // Sizes
        const sizes = {
            width: window.innerWidth,
            height: window.innerHeight,
        }
        //Camera
        const cameraGroup = new THREE.Group();
        const camera = new THREE.PerspectiveCamera(24, sizes.width / sizes.height)
        camera.position.z = 12;
        cameraGroup.add(camera);
        scene.add(cameraGroup);

        // Renderer
        const renderer = new THREE.WebGLRenderer({
            canvas,
            alpha: true,
            antialias: true,
        })
        renderer.setPixelRatio(devicePixelRatio);
        renderer.shadowMap.enabled = true;
        renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        //renderer.setClearColor(0x0e0e0e, 0.0);
        //renderer.physicallyCorrectLights
        //renderer.outputEncoding = THREE.sRGBEncoding;
        renderer.toneMapping = THREE.CineonToneMapping;

        // Assign
        const objectDistance = 4;
        // Mesh & Materials
        let beehive;
        let mtl_dark, mtl_dark_skin, mtl_stand, mtl_dark_hive, mtl_dark_bee;
        // Load models
        let model, bear, bearGroup, chair, stand;
        let book, chat, color, cup, mac, musicnote_1, musicnote_2, pen, phone;
        let array, array_2;
        let root, head, neck, thighL, thighR, footR, footL;
        let hive, hiveGroup, mixerHive;
        //Lights
        let directLight, directLight2, directLight3, directLight4, directLight5;
        let spotLight, rimLight;
        // Trigger boolean
        let allowFollowMouse = false;

        // Materials
        mtl_dark = new THREE.MeshStandardMaterial({
            color: 0x020202,
            flatShading: true,
            roughness: .85,
            metalness: 1,
            transparent: true,
            opacity: 1,
            emissive: 0x0e0e0e,
            //wireframe: true
        })
        mtl_stand = new THREE.MeshStandardMaterial({
            color: 0x020202,
            flatShading: true,
            roughness: .85,
            metalness: 1,
            transparent: true,
            opacity: 1,
            emissive: 0x0e0e0e,
            //wireframe: true,
        })
        mtl_dark_skin = new THREE.MeshStandardMaterial({
            color: 0x020202,
            flatShading: true,
            roughness: .85,
            metalness: 1,
            transparent: true,
            opacity: 1,
            emissive: 0x0e0e0e,
            skinning: true,
            //wireframe: true,
        })
        mtl_dark_hive = new THREE.MeshStandardMaterial({
            color: 0x020202,
            //flatShading: true,
            roughness: .85,
            metalness: 1,
            transparent: true,
            opacity: 1,
            emissive: 0x0e0e0e,
        })
        mtl_dark_bee = new THREE.MeshStandardMaterial({
            color: 0x020202,
            flatShading: true,
            roughness: .85,
            metalness: 1,
            transparent: true,
            opacity: 1,
            emissive: 0x0e0e0e,
            skinning: true,
        })

        const parameters = {
            lightIntensity: 2,
            sceneBackground: false,
            sobel: false,
            rgbShift: false,
            glitch: false,
            glitchWild: false,
            bokeh: false,
            ssaa: false,
            ssao: false,
            toneMap: false,
        }

        // Post-processing
        const renderTarget = new THREE.WebGLRenderTarget(
            sizes.width,
            sizes.height,
            {
                // Anti-aliasing for WebGL2
                samples: renderer.getPixelRatio() === 1 ? 2 : 0,
            }
        )

        const composer = new EffectComposer(renderer);
        composer.setSize(sizes.width, sizes.height);
        composer.setPixelRatio(devicePixelRatio);

        // const clearPass = new ClearPass(0x0e0e0e, 0);
        // composer.addPass(clearPass)
        const renderPass = new RenderPass(scene, camera);
        composer.addPass(renderPass);
        //renderPass.clear = false

        const dotScreenPass = new DotScreenPass()
        dotScreenPass.enabled = false;
        composer.addPass(dotScreenPass);

        const glitchPass = new GlitchPass()
        glitchPass.goWild = parameters.glitchWild;
        glitchPass.enabled = parameters.glitch;
        composer.addPass(glitchPass);

        const rgbShiftPass = new ShaderPass(RGBShiftShader);
        rgbShiftPass.enabled = parameters.rgbShift;
        rgbShiftPass.uniforms.amount.value = .0025;
        composer.addPass(rgbShiftPass);

        const unrealBloomPass = new UnrealBloomPass();
        unrealBloomPass.threshold = 1;
        unrealBloomPass.strength = 1;
        unrealBloomPass.radius = 1;
        //composer.addPass(unrealBloomPass)

        // Anti-aliasing for WebGL1
        if (renderer.getPixelRatio() === 1 && !renderer.capabilities.isWebGL2) {
            const smaaPass = new SMAAPass();
            composer.addPass(smaaPass);

            console.log('Using SMAA')
        }

        const effectSobel = new ShaderPass(SobelOperatorShader);
        effectSobel.enabled = parameters.sobel;
        effectSobel.uniforms['resolution'].value.x = sizes.width * devicePixelRatio;
        effectSobel.uniforms['resolution'].value.y = sizes.height * devicePixelRatio;
        composer.addPass(effectSobel)

        const bokehPass = new BokehPass(scene, camera, {
            aperture: .0004,
            maxblur: 0.1,
            width: sizes.width,
            height: sizes.height
        });
        bokehPass.uniforms['focus'].value = 12;
        bokehPass.enabled = parameters.bokeh;
        composer.addPass(bokehPass)

        const ssaaRenderPass = new SSAARenderPass(scene, camera);
        ssaaRenderPass.enabled = parameters.ssaa;
        composer.addPass(ssaaRenderPass)

        const ssaoPass = new SSAOPass(scene, camera, sizes.width, sizes.height);
        ssaoPass.kernelRadius = 16;
        ssaoPass.enabled = parameters.ssao;
        composer.addPass(ssaoPass);

        composer.renderTarget = renderTarget;

        // Lightings 
        function addLights() {
            directLight = new THREE.DirectionalLight(0xffffff, parameters.lightIntensity * 4);
            directLight.position.set(3, 1.5, -1);
            directLight.target.position.set(0, 2, 0);
            directLight.castShadow = true;
            scene.add(directLight.target);
            scene.add(directLight);
            directLight.shadow.mapSize.width = 2048;
            directLight.shadow.mapSize.height = 2048;

            directLight2 = new THREE.DirectionalLight(0xffffff, parameters.lightIntensity * 3);
            directLight2.position.set(-3, 1.5, -1);
            directLight2.target.position.set(0, 2, 0);
            directLight2.castShadow = true;
            scene.add(directLight2.target);
            scene.add(directLight2);
            directLight2.shadow.mapSize.width = 2048;
            directLight2.shadow.mapSize.height = 2048;

            directLight3 = new THREE.DirectionalLight(0xffffff, parameters.lightIntensity * 2);
            directLight3.position.set(3, 2, 0);
            directLight3.target.position.set(0, 0, -1);
            directLight3.castShadow = true;
            scene.add(directLight3.target);
            scene.add(directLight3);

            directLight4 = new THREE.DirectionalLight(0xffffff, parameters.lightIntensity * 2);
            directLight4.position.set(-3, 2, 0);
            directLight4.target.position.set(0, 0, -1);
            directLight4.castShadow = true;
            scene.add(directLight4.target);
            scene.add(directLight4);

            directLight5 = new THREE.DirectionalLight(0xffffff, parameters.lightIntensity * 3);
            directLight5.position.set(0, 3, 2);
            directLight5.target.position.set(0, 0, -1);
            directLight5.castShadow = true;
            scene.add(directLight5.target);
            scene.add(directLight5);

            spotLight = new THREE.SpotLight(
                0xffffff,
                0,
                0,
                Math.PI / 4,
                .1,
                parameters.lightIntensity * 1
            );
            spotLight.penumbra = .75
            spotLight.position.set(-2, -3, -3);

            rimLight = new THREE.SpotLight(
                0xffffff,
                2,
                0,
                Math.PI / 4,
                .1,
                parameters.lightIntensity * 1
            );
            rimLight.position.set(0, 0, -3);

            scene.add(spotLight);
            scene.add(rimLight);
            animLight();
        }
        addLights();

        function animLight() {
            const tlLight = gsap.timeline({
                defaults: {
                    ease: "none"
                }
            });
            tlLight.to(spotLight.position, { x: -2.5, y: 0, duration: .6, delay: 1 })
                .to(spotLight, { intensity: parameters.lightIntensity * 1, duration: .6 }, '<0')
                .to(spotLight.position, { x: -2, y: 3, duration: .6 }, '<0.6')
                .to(spotLight.position, { x: 2, y: 3, duration: .8, })
                .to(spotLight.position, { x: 2.5, y: 0, duration: .6, })
                .to(spotLight.position, { x: 2, y: -3, duration: .6, })
                .to(spotLight, { intensity: 0, duration: .6 }, '<0')

            const tlLight2 = gsap.timeline({
                delay: tlLight.duration() / 3 * 2,
                onComplete: () => {
                    document.querySelector('.sc-home-hero').classList.remove('hide')
                    document.querySelector('.header').classList.remove('before-loading')
                    allowFollowMouse = true;
                }
            });
            tlLight2
                .from(directLight, { intensity: 0, duration: 1.2 }, '>.4')
                .from(directLight2, { intensity: 0, duration: 1.2 }, '<0')
                .from([directLight3, directLight4, directLight5], { intensity: 0, duration: 1.2, stagger: 0.1 }, '<0')
                .from(rimLight, { intensity: 0, duration: 1.2 }, '<0')
                .to('.blur-bg', { opacity: .5, duration: .6 }, '<0')
        }

        // draco
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('https://raw.githubusercontent.com/mrdoob/three.js/dev/examples/jsm/libs/draco/');
        dracoLoader.setDecoderConfig({ type: 'js' })
        dracoLoader.preload();

        // gltf
        const gltfLoader = new GLTFLoader();
        gltfLoader.setDRACOLoader(dracoLoader)

        //Load models
        gltfLoader.load('../../img/bp2-4-comp.glb', (glb) => {
            bear = glb.scene
            bearGroup = new THREE.Group();
            bearGroup.add(bear)
            scene.add(bearGroup)
            // Customize models 
            bear.traverse((obj) => {
                if (obj.isMesh) {
                    if (obj.name == 'bear') {
                        model = obj;
                        model.material = mtl_dark_skin;
                        model.castShadow = true
                        model.receiveShadow = true
                    } else {
                        obj.material = mtl_dark
                        obj.receiveShadow = true
                    }
                }
                switch (obj.name) {
                    case "book":
                        book = obj;
                        break;
                    case "chat":
                        chat = obj;
                        break;
                    case "color":
                        color = obj;
                        break;
                    case "cup":
                        cup = obj;
                        break;
                    case "mac":
                        mac = obj;
                        break;
                    case "musicnote_1":
                        musicnote_1 = obj;
                        break;
                    case "musicnote_2":
                        musicnote_2 = obj;
                        break;
                    case "pen":
                        pen = obj;
                        break;
                    case "phone":
                        phone = obj;
                        break;
                    case "chair":
                        chair = obj;
                        chair.castShadow = true;
                        chair.receiveShadow = true;
                        break;
                    case "head":
                        head = obj;
                        break;
                    case "neck":
                        neck = obj;
                        break;
                    case "root":
                        root = obj;
                        break;
                    case "thighL":
                        thighL = obj;
                        break;
                    case "thighR":
                        thighR = obj;
                        break;
                    case "footR":
                        footR = obj;
                        break;
                    case "footL":
                        footL = obj;
                        break;
                    default:
                        break;
                }
            })
            initAnimStuffs();
            setTimeout(() => {
                window.SCROLL.start();
                initBearInteraction();
            }, 5800);
            requestAnimationFrame(tick);
        })
        let standGroup = new THREE.Group()
        gltfLoader.load('../../img/bp-standing.glb', (glb) => {
            Emitter.emit(EVENT.EXPERIENCE_LOADED2);
            stand = glb.scene;
            stand.position.z = 8;
            stand.scale.set(2.2, 2.2, 2.2)
            standGroup.add(stand);
            scene.add(standGroup)
            console.log(stand)
            stand.position.y = -1 * objectDistance;
            stand.traverse((obj) => {
                if (obj.name == 'bear-standing') {
                    obj.material = mtl_stand;
                    obj.castShadow = true;
                    obj.receiveShadow = true;
                }
            })

            initBearStandAnim();
        })
        hiveGroup = new THREE.Group();
        gltfLoader.load('../img/bp2-hive-3.glb', (glb) => {
            hive = glb.scene;
            hive.position.x = -3.2;
            hive.position.z = 12;
            hive.position.y = -1 * objectDistance;
            hive.traverse((obj) => {
                if (obj.isMesh) {
                    if (obj.name == 'hive') {
                        obj.material = mtl_dark_hive;
                    } else {
                        obj.material = mtl_dark_bee;
                    }
                }
            })
            mixerHive = new THREE.AnimationMixer(hive);
            mixerHive.timeScale = 14;
            const clip = glb.animations.find((clip) => clip.name === 'hive-animation');
            let animHive = mixerHive.clipAction(clip);
            console.log(glb.animations)
            animHive.play();
            hiveGroup.add(hive)
            scene.add(hiveGroup)
        })

        //dat GUI
        const gui = new dat.GUI();
        let folder_bear = gui.addFolder('mtl_bear');
        let folder_objects = gui.addFolder('mtl_objects');
        let folder_stand = gui.addFolder('mtl_stand');
        let folder_lights = gui.addFolder('lightings');
        let folder_postPro = gui.addFolder('postprocessing');
        folder_bear.add(mtl_dark_skin, 'roughness', 0, 1, 0.05).name('mtl_roughness')
        folder_bear.add(mtl_dark_skin, 'metalness', 0, 1, 0.05).name('mtl_metalness')
        folder_bear.add(mtl_dark_skin, 'wireframe')
        folder_objects.add(mtl_dark, 'roughness', 0, 1, 0.05).name('mtl_roughness')
        folder_objects.add(mtl_dark, 'metalness', 0, 1, 0.05).name('mtl_metalness')
        folder_objects.add(mtl_dark, 'wireframe')
        folder_stand.add(mtl_stand, 'roughness', 0, 1, 0.05).name('mtl_roughness')
        folder_stand.add(mtl_stand, 'metalness', 0, 1, 0.05).name('mtl_metalness')
        folder_stand.add(mtl_stand, 'wireframe')
        folder_lights.add(parameters, 'lightIntensity', 0.5, 8, 0.5).name('light_intensity').onChange(() => {
            directLight.intensity = parameters.lightIntensity * 4;
            directLight2.intensity = parameters.lightIntensity * 3;
            directLight3.intensity = parameters.lightIntensity * 2;
            directLight4.intensity = parameters.lightIntensity * 2;
            directLight5.intensity = parameters.lightIntensity * 3;
            rimLight.intensity = parameters.lightIntensity * 1;
        })
        folder_postPro.add(parameters, 'sceneBackground').onChange(function () {
            parameters.sceneBackground ? scene.background = new THREE.Color('#0e0e0e') : scene.background = null
        })
        folder_postPro.add(parameters, 'toneMap').onChange(() => {
            if (parameters.toneMap) {
                renderer.toneMapping = THREE.CineonToneMapping
            } else {
                renderer.toneMapping = THREE.NoToneMapping;
            }
        })
        folder_postPro.add(parameters, 'sobel').onChange(() => { effectSobel.enabled = parameters.sobel })
        folder_postPro.add(parameters, 'glitch').onChange(() => { glitchPass.enabled = parameters.glitch })
        folder_postPro.add(parameters, 'glitchWild').onChange(() => { glitchPass.goWild = parameters.glitchWild })
        folder_postPro.add(parameters, 'rgbShift').onChange(() => { rgbShiftPass.enabled = parameters.rgbShift })
        folder_postPro.add(parameters, 'bokeh').onChange(() => { bokehPass.enabled = parameters.bokeh })
        folder_postPro.add(parameters, 'ssaa').onChange(() => { ssaaRenderPass.enabled = parameters.ssaa })
        folder_postPro.add(parameters, 'ssao').onChange(() => { ssaoPass.enabled = parameters.ssao })

        function initBearInteraction() {
            allowFollowMouse = true;
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: '.sc-home-hero',
                    start: 'top top',
                    end: 'bottom top',
                    scrub: 0,
                    onLeave: () => {
                        gsap.set('.experience', { 'filter': 'blur(0px)', overwrite: true });
                        gsap.to('.grad-bg', { autoAlpha: 1, duration: 1, overwrite: true });
                        document.querySelector('.sc-home-about').style.zIndex = '1';
                    },
                    onEnterBack: () => {
                        gsap.to('.grad-bg', { autoAlpha: 0, duration: 1, overwrite: true });
                        document.querySelector('.sc-home-about').style.zIndex = '5';
                    }
                },
                defaults: {
                    ease: 'none'
                },
                onUpdate: function () {
                    if (this.progress() >= 0.33) {
                        allowFollowMouse = false;
                    } else {
                        allowFollowMouse = true;
                    }
                }
            })
            tl.to(bearGroup.rotation, { y: Math.PI, duration: 10 }, '0')
                .to('.sc-home-hero', { yPercent: 33, duration: 10 }, '0')
                .to('.sc-home-hero .home-hero-grad', { yPercent: -100, duration: 20 }, '0')
                .to(bearGroup.position, { z: 10, duration: 20 }, '10')
                .to(mtl_dark_skin, { opacity: 0, duration: 1, }, '>-=1')
                .to(mtl_dark, { opacity: 0, duration: 1, }, '<0')
                .to('.experience', { 'filter': 'blur(14px)', duration: 3 }, '<-=3')
        }
        function initAnimStuffs() {
            let stuffs = bear.children[1].children;
            stuffs.forEach(function (e, i) {
                let timeDelay = i * 0.08 + 3
                gsap.from(e.scale, { x: 0, y: 0, z: 0, duration: 1.2, ease: "Power2.easeOut", delay: timeDelay })
                gsap.from(e.position, { y: 0, z: 0, duration: 1.2, ease: "Power2.easeOut", delay: timeDelay })
                gsap.from(e.rotation, { y: -2, z: -2, duration: 1.2, ease: "Power2.easeOut", delay: timeDelay })
            })
        }
        function initBearFollowMouse(e) {
            let mousecoords = e;
            const moveJointHead = (mouse, joint, degreeLimit) => {
                let degrees = getMouseDegrees(mouse.x, mouse.y, degreeLimit);
                joint.rotation.z = THREE.MathUtils.lerp(
                    joint.rotation.z,
                    ((0.0405 + THREE.Math.degToRad(degrees.x)) * Math.PI) / 10,
                    0.1
                );
                joint.rotation.x =
                    0.14 +
                    THREE.MathUtils.lerp(
                        joint.rotation.x,
                        ((0.2 - THREE.Math.degToRad(degrees.y)) * Math.PI) / 10,
                        0.1
                    );
            };
            const moveJointNeck = (mouse, joint, degreeLimit) => {
                let degrees = getMouseDegrees(mouse.x, mouse.y, degreeLimit);
                joint.rotation.y = THREE.MathUtils.lerp(
                    joint.rotation.y,
                    (THREE.Math.degToRad(degrees.x) * Math.PI) / 10,
                    0.1
                );
                joint.rotation.x =
                    0.05 +
                    THREE.MathUtils.lerp(
                        joint.rotation.x,
                        ((0.8767 - THREE.Math.degToRad(degrees.y)) * Math.PI) / 10,
                        0.1
                    );
            };
            const moveJointBase = (mouse, joint, degreeLimit) => {
                let degrees = getMouseDegrees(mouse.x, mouse.y, degreeLimit);
                joint.rotation.y = THREE.MathUtils.lerp(
                    joint.rotation.y,
                    (THREE.Math.degToRad(degrees.x) * Math.PI) / 10,
                    0.1
                );
                joint.rotation.x = THREE.MathUtils.lerp(
                    joint.rotation.x,
                    (THREE.Math.degToRad(degrees.y) * Math.PI) / 10,
                    0.1
                );
            };
            moveJointHead(mousecoords, head, -60);
            moveJointNeck(mousecoords, neck, 15);
            moveJointBase(mousecoords, bear, 24);
        }
        function anim_hovering(stuff) {
            stuff.position.y += Math.sin(1 * 1000 + clock.elapsedTime) / 1200;
            stuff.rotation.x +=
                (Math.sin(1 * 1000 + clock.elapsedTime) * Math.PI) / 2000;
            stuff.rotation.y +=
                (Math.cos(1 * 1000 + clock.elapsedTime) * Math.PI) / 3000;
            stuff.rotation.z +=
                (Math.sin(1 * 1000 + clock.elapsedTime) * Math.PI) / 4000;
        }
        function anim_hovering_2(stuff) {
            stuff.position.y -= Math.sin(1 * 1000 + clock.elapsedTime) / 1000;
            stuff.rotation.x +=
                (Math.sin(1 * 1000 + clock.elapsedTime) * Math.PI) / 2000;
            stuff.rotation.y +=
                (Math.cos(1 * 1000 + clock.elapsedTime) * Math.PI) / 3000;
            stuff.rotation.z +=
                (Math.sin(1 * 1000 + clock.elapsedTime) * Math.PI) / 4000;
        }
        function initBearStandAnim() {
            const tlStand = gsap.timeline({
                scrollTrigger: {
                    trigger: '.sc-home-proj',
                    start: 'top bottom+=200%',
                    end: 'bottom+=20% bottom',
                    scrub: 0,
                    //markers: true,
                    onEnter: () => {
                        allowFollowMouse = true;
                        gsap.set('.experience', { 'filter': 'blur(0px)' })
                        console.log('enter')
                    },
                    onLeaveback: () => {
                        allowFollowMouse = false;
                        gsap.set('.experience', { 'filter': 'blur(8px)' })
                    }
                },
                default: {
                    ease: 'none'
                }
            })
            setTimeout(() => {
                tlStand
                    //.to(hive.position, { x: -3.1, z: 0, y: -.4 * objectDistance, duration: 10 })
                    .to(hive.position, { x: -3.1, z: 0, y: .2 * objectDistance, duration: 15 }, '0')
                    //.to(stand.position, { y: -.6 * objectDistance, z: -5.6, duration: 10 }, '0')
                    .to(stand.position, { y: -.1 * objectDistance, z: -5.6, duration: 15 }, '0')
                    .to('.experience', { 'filter': 'blur(6px)', duration: 4 }, '5')
                    .from(stand.rotation, { y: Math.PI / 2, duration: 15 }, '0')

                //.to(mtl_stand, { opacity: 0, duration: 2 }, '>-=2')    
            }, 3000);
        }

        renderer.setSize(sizes.width, sizes.height);
        renderer.render(scene, camera);

        // Times
        const clock = new THREE.Clock();
        let previousTime = 0;

        // Mouse 
        let cursor = {};
        cursor.x = 0;
        cursor.y = 0;

        let followCursor = {}
        followCursor.x = 0;
        followCursor.y = 0;

        let raycasterCursor = {};
        raycasterCursor.x = 0;
        raycasterCursor.y = 0;

        const raycaster = new THREE.Raycaster();

        window.addEventListener('mousemove', function (e) {
            cursor.x = (e.clientX / sizes.width) - .5;
            cursor.y = (e.clientY / sizes.height) - .5;
            followCursor.x = getMousePos(e).x;
            followCursor.y = getMousePos(e).y;
            raycasterCursor.x = cursor.x * 2;
            raycasterCursor.y = cursor.y * - 2;
        })

        // Scroll
        let scrollY = window.scrollY;

        window.addEventListener('scroll', () => {
            scrollY = window.scrollY;
        })

        const tick = () => {
            const elapsedTime = clock.getElapsedTime();
            const deltaTime = elapsedTime - previousTime;
            previousTime = elapsedTime;

            // Animate camera
            cameraGroup.position.y = - scrollY / sizes.height * objectDistance;
            standGroup.position.y = - scrollY / sizes.height * objectDistance;
            bearGroup.position.y = - scrollY / sizes.height * objectDistance;
            hiveGroup.position.y = - scrollY / sizes.height * objectDistance;
            // Parallax 
            const parallaxX = cursor.x;
            const parallaxY = cursor.y;

            // Idle Anim stuffs and bone

            if (bear) {
                if (allowFollowMouse) {
                    initBearFollowMouse(followCursor);
                    camera.position.x += (parallaxX - camera.position.x) * .8 * deltaTime;
                    //camera.position.y += (- parallaxY - camera.position.y) * .5 * deltaTime;
                } else {
                    if (bear.rotation.y > 0) {
                        bear.rotation.y += (0 - bear.rotation.y) * .9 * deltaTime;
                    }
                    if (camera.position.x > 0) {
                        camera.position.x += (0 - camera.position.x) * .9 * deltaTime;
                    }
                }
                array = [chat, cup, mac, pen, phone];
                array.map((item) => {
                    anim_hovering(item);
                });
                array_2 = [book, color, musicnote_1, musicnote_2];
                array_2.map((item) => {
                    anim_hovering_2(item);
                });
                chair.position.y -= Math.sin(1 * 1000 + elapsedTime) / 2400;
                root.position.y -= Math.sin(1 * 1000 + elapsedTime) / 1400;
                thighL.position.y -= Math.sin(1 * 1000 + elapsedTime) / 1000;
                thighR.position.y -= Math.sin(1 * 1000 + elapsedTime) / 1000;

                // Raycaster
                raycaster.setFromCamera(raycasterCursor, camera);
                const array_3 = [...array, ...array_2];
                const intersects = raycaster.intersectObjects(array_3);

                for (const intersect of intersects) {
                    //console.log(intersect.object)
                    //intersect.object.material.color.set('#00ff00')
                    //intersect.object.scale.x = Math.sin(1 * 1000 + elapsedTime);
                }
                // for (const obj_stuff of array_3) {
                //     if (!intersects.find(intersect => intersect.object === obj_stuff)) {
                //         obj_stuff.material.color.set('#030303');
                //     }
                // }
            }

            if (mixerHive) {
                mixerHive.update(clock.getDelta() * mixerHive.timeScale);
            }

            //Without post-pro
            //renderer.render(scene, camera);

            // With post-pro
            composer.render();

            requestAnimationFrame(tick)
        }
        window.addEventListener('resize', onWindowResize);
        function onWindowResize() {
            sizes.width = window.innerWidth;
            sizes.height = window.innerHeight;
            //Update camera
            camera.aspect = sizes.width / sizes.height;
            camera.updateProjectionMatrix();
            //Update renderer
            renderer.setSize(sizes.width, sizes.height);
            renderer.setPixelRatio(devicePixelRatio);
            //Update composer
            composer.setSize(sizes.width, sizes.height);
            composer.setPixelRatio(devicePixelRatio)

        }
    }
}

// spotLight = new THREE.SpotLight(
//     0xffffff,
//     0,
//     0,
//     Math.PI / 64,
//     .1,
//     parameters.lightIntensity * 2
// );

// spotLight.position.set(-4, -4, -20);
// dummy = new THREE.Group()
// dummy.position.set(-4, -4, -5);
// scene.add(dummy)
// spotLight.lookAt(dummy)

// const tlLight = gsap.timeline({
//     defaults: {
//         ease: "none"
//     }
// });
// tlLight.to(spotLight.position, { x: -3, y: 0, duration: .6, delay: 1 })
//     .to(spotLight, { intensity: parameters.lightIntensity * 1, duration: .6 }, '<0')
//     .to(spotLight.position, { x: -2, y: 7, duration: .6 }, '<0.6')
//     .to(spotLight.position, { x: 2, y: 7, duration: .8, })
//     .to(spotLight.position, { x: 3, y: 0, duration: .6, })
//     .to(spotLight.position, { x: 2, y: -3, duration: .6, })
//     .to(spotLight, { intensity: 0, duration: .6 }, '<0')
// const dummyTl = gsap.timeline({
//     defaults: {
//         ease: "none"
//     }
// });
// dummyTl.to(dummy.position, { x: -3, y: 0, duration: .6, delay: 1 })
//     .to(dummy.position, { x: -2, y: 7, duration: .6 }, '<0.6')
//     .to(dummy.position, { x: 2, y: 7, duration: .8, })
//     .to(dummy.position, { x: 3, y: 0, duration: .6, })
//     .to(dummy.position, { x: 2, y: -3, duration: .6, })